import React from "react";
import { FaPhoneAlt, FaFacebook, FaInstagram } from "react-icons/fa";
import Wave from "react-wavify";

import "./footer.css";

const Footer = () => {
  return (
    <div className="footer">
      <div className="wave">
        <Wave
          fill="#ebeaeb"
          paused={false}
          options={{
            height: 20,
            amplitude: 45,
            speed: 0.1,
            points: 5,
          }}
        />
      </div>
      <div className="contacto" id="contacto">
        <div>
          <FaPhoneAlt className="circulo" />
        </div>
        <h3>+549 - 3546 406591</h3>
        <p className="consultas">consultas y/o reservas</p>

        <div className="redes">
          <div>
            <p>Seguinos</p>
          </div>
          <div className="redes_iconos">
            <span>
              <a
                href="https://www.facebook.com/cerrocristal2019/"
                target="_blank"
                rel="noreferrer"
              >
                <FaFacebook />
              </a>
            </span>
            <span>
              <a
                href="https://www.instagram.com/cerrocristal.cumbrecita/"
                target="_blank"
                rel="noreferrer"
              >
                <FaInstagram />
              </a>
            </span>
          </div>
        </div>
      </div>
      <div className="derechos">
        <p>Cabañas Cerro Cristal - la cumbrecita</p>
      </div>
    </div>
  );
};

export default Footer;
